import React from 'react';

const Bed = ({ imag }) => {
    const { img } = imag;
    return (
        <div className=''>

            <img className='' src={img}></img>

        </div>
    );
};

export default Bed;
